/**
 * Variant Gate — Fuerza selección de variante antes de agregar al carrito.
 *
 * Flujo:
 *   1. Al cargar la página, deselecciona todas las opciones de variante.
 *   2. Deshabilita el botón "Agregar al carrito".
 *   3. Muestra el mensaje "Debes seleccionar una variante…".
 *   4. Cuando el usuario selecciona una variante, oculta el mensaje
 *      y deja que el flujo nativo de Craft maneje el botón.
 *
 * Compatible con:
 *   - Radio buttons (pastillas)
 *   - Swatches
 *   - Dropdowns (select)
 *   - Re-renders dinámicos de sección (Shopify Online Store 2.0)
 *   - AJAX Add To Cart nativo de Craft
 *   - Dynamic checkout buttons
 *
 * No depende de jQuery.
 * No modifica window.variantStrings.
 * No intercepta el formulario.
 */
(function () {
  'use strict';

  /**
   * Inicializa la puerta de variantes para cada <product-info> en la página.
   * Solo actúa en productos con múltiples variantes.
   */
  function initVariantGate() {
    var variantSelectors = document.querySelectorAll('variant-selects');
    if (!variantSelectors.length) return;

    variantSelectors.forEach(function (vs) {
      var productInfo = vs.closest('product-info');
      if (!productInfo) return;

      // Si ya fue procesado en este ciclo, salir
      if (productInfo.dataset.variantGateInitialized === 'true') return;

      var sectionId = productInfo.dataset.section;
      var productFormEl = productInfo.querySelector('product-form');
      if (!productFormEl) return;

      var form = productFormEl.querySelector('form');
      var submitBtn = productFormEl.querySelector('[type="submit"]');
      if (!form || !submitBtn) return;

      // ── 1. Deseleccionar todos los radio buttons / swatches ──
      vs.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
        input.checked = false;
      });

      // ── 2. Limpiar texto de valor seleccionado en la leyenda ──
      vs.querySelectorAll('[data-selected-value]').forEach(function (el) {
        el.textContent = '';
      });

      // ── 3. Para dropdowns: insertar opción placeholder vacía ──
      vs.querySelectorAll('select.select__select').forEach(function (select) {
        // Deseleccionar la opción actual
        Array.from(select.options).forEach(function (opt) {
          opt.removeAttribute('selected');
          opt.selected = false;
        });
        // Insertar placeholder al inicio
        if (!select.querySelector('[data-variant-gate-placeholder]')) {
          var placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.textContent = 'Seleccionar...';
          placeholder.setAttribute('data-variant-gate-placeholder', 'true');
          placeholder.setAttribute('disabled', 'true');
          placeholder.selected = true;
          select.insertBefore(placeholder, select.firstChild);
        }
      });

      // ── 4. Limpiar y deshabilitar el input oculto de variant ID ──
      var variantIdInput = form.querySelector('input[name="id"]');
      if (variantIdInput) {
        variantIdInput.value = '';
        variantIdInput.disabled = true;
      }

      // ── 5. Deshabilitar el botón de submit ──
      submitBtn.setAttribute('disabled', 'disabled');

      // ── 6. Ocultar dynamic checkout buttons si existen ──
      var dynamicCheckout = productFormEl.querySelector('.shopify-payment-button');
      if (dynamicCheckout) {
        dynamicCheckout.style.display = 'none';
        dynamicCheckout.setAttribute('data-variant-gate-hidden', 'true');
      }

      // ── 7. Mostrar el mensaje de advertencia ──
      var message = productInfo.querySelector('#VariantGateMessage-' + sectionId);
      if (message) {
        message.removeAttribute('hidden');
      }

      // ── 8. Marcar como inicializado y activo ──
      productInfo.dataset.variantGateInitialized = 'true';
      productInfo.dataset.variantGateActive = 'true';
    });
  }

  /**
   * Cuando el usuario selecciona una variante, ocultamos el mensaje
   * y restauramos los dynamic checkout buttons.
   * El botón de submit es manejado por el flujo nativo de Craft
   * (product-info.js → toggleSubmitButton).
   */
  function onVariantSelected(productInfo) {
    if (!productInfo || productInfo.dataset.variantGateActive !== 'true') return;

    var sectionId = productInfo.dataset.section;

    // Ocultar mensaje
    var message = productInfo.querySelector('#VariantGateMessage-' + sectionId);
    if (message) {
      message.setAttribute('hidden', '');
    }

    // Restaurar dynamic checkout buttons
    var dynamicCheckout = productInfo.querySelector('[data-variant-gate-hidden="true"]');
    if (dynamicCheckout) {
      dynamicCheckout.style.display = '';
      dynamicCheckout.removeAttribute('data-variant-gate-hidden');
    }

    // Re-habilitar variant ID input (Craft lo manejará a partir de aquí)
    var productFormEl = productInfo.querySelector('product-form');
    if (productFormEl) {
      var variantIdInput = productFormEl.querySelector('form input[name="id"]');
      if (variantIdInput) {
        variantIdInput.disabled = false;
      }
    }

    // Desactivar la puerta — el flujo nativo toma el control
    productInfo.dataset.variantGateActive = 'false';
  }

  // ── Suscribirse al evento de cambio de opción (pub/sub nativo de Craft) ──
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (eventData) {
      var target = eventData.data.event.target;
      var productInfo = target.closest('product-info');
      onVariantSelected(productInfo);
    });
  }

  // ── Ejecutar cuando el DOM esté listo ──
  // Los scripts con defer (constants.js, pubsub.js, global.js, product-form.js,
  // product-info.js) ya se ejecutaron antes de DOMContentLoaded.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantGate);
  } else {
    initVariantGate();
  }
})();
